import { render, staticRenderFns } from "./InvoiceSummaryDashboard.vue?vue&type=template&id=72df4b87&"
import script from "./InvoiceSummaryDashboard.vue?vue&type=script&lang=js&"
export * from "./InvoiceSummaryDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports